import { getAttributeValue } from '@theme/dom';
import { HTMLShopifySectionElement } from '@theme/html-custom-element';

class BlogHeroSlider extends HTMLShopifySectionElement {
  connectedCallback() {
    if (super.connectedCallback) super.connectedCallback();

    Object.assign(this.refs.slider, {
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      loop: true,
      allowTouchMove: false,
      autoplay: getAttributeValue(this, 'autoplay', false)
        ? {
            delay: getAttributeValue(this, 'autoplay-delay', 5000),
          }
        : false,
      pagination: {
        el: this.refs.pagination,
        clickable: true,
        renderBullet: (index, className) =>
          `<span class="${className} text-12-book">${(index + 1).toString().padStart(2, '0')}</span>`,
      },
    });

    this.refs.slider.initialize();
  }

  onBlockSelect(event) {
    this.refs.slider.swiper.slideToLoop(Number(event.target.dataset.index0), 0);

    if (this.refs.slider.swiper.autoplay.running) {
      this.refs.slider.swiper.autoplay.pause();
    }
  }

  onBlockDeselect() {
    if (this.refs.slider.swiper.autoplay.running) {
      this.refs.slider.swiper.autoplay.resume();
    }
  }
}

if (!customElements.get('blog-hero-slider')) customElements.define('blog-hero-slider', BlogHeroSlider);
